import {SearchOutlined} from '@ant-design/icons';
import {Input} from 'antd';
import PropTypes from 'prop-types';
import {useState} from 'react';

const SearchBar = ({onSearch, placeholder = 'Search...', width = 200}) => {
  const [value, setValue] = useState('');

  return (
    <Input
      placeholder={placeholder}
      prefix={<SearchOutlined />}
      value={value}
      onChange={e => {
        setValue(e.target.value);
        onSearch(e.target.value);
      }}
      onPressEnter={() => onSearch(value)}
      onBlur={() => onSearch(value)}
      style={{width}}
    />
  );
};

SearchBar.propTypes = {
  onSearch: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  width: PropTypes.number,
};

export default SearchBar;
